import { useEffect, useState } from 'react'

const MAP_CONTAINER_ID = 'map-container'
const CONTENT_CONTAINER_ID = 'content-container'

export const setPixelHeights = () => {
  const heightValueToSet = `${window.innerHeight - 197}px`

  const htmlElement = document.querySelector('html')
  if (htmlElement) htmlElement.style.height = `${window.innerHeight}px`

  const mapContainerElement = document.getElementById(MAP_CONTAINER_ID)
  if (mapContainerElement) mapContainerElement.style.height = heightValueToSet

  const contentContainerElement = document.getElementById(CONTENT_CONTAINER_ID)
  if (contentContainerElement) contentContainerElement.style.height = heightValueToSet
}

type IUseWindowHeightCorrection = (widths: {
  isMobile: boolean | undefined
  isDesktopMedium: boolean | undefined
  mobileHeaderHeight: number
}) => {
  CONTENT_CONTAINER_ID: string
  MAP_CONTAINER_ID: string
}

/**
 * on mobile, we have to change our document height from 100vh to a pixel value in order to
 * accomodate the way iOS and Android overlay browser controls over HTML page content
 *
 * adapted from: https://medium.com/quick-code/100vh-problem-with-ios-safari-92ab23c852a8
 *
 * @FIXME: There is probably a way to do all of this in pure CSS but I was not smart enough to
 * figure it out :~)
 */

const useWindowHeightCorrection: IUseWindowHeightCorrection = ({
  isMobile,
  isDesktopMedium,
  mobileHeaderHeight,
}) => {
  useEffect(() => {
    if (!isMobile) return

    window.addEventListener('resize', setPixelHeights)
    setPixelHeights()

    return () => {
      window.removeEventListener('resize', setPixelHeights)
      const htmlElement = document.querySelector('html')
      if (htmlElement) htmlElement.style.removeProperty('height')
    }
  }, [isMobile])

  // edge cases

  // if the user begins on desktop with a mobile-size viewport width, expanding to desktop width
  // needs to unset the fixed pixel values
  useEffect(() => {
    if (isDesktopMedium) {
      window.removeEventListener('resize', setPixelHeights)

      const heightValueToReset = `calc(100vh - ${mobileHeaderHeight}px)`

      const htmlElement = document.querySelector('html')
      if (htmlElement) htmlElement.style.removeProperty('height') // unset by default

      const mapContainerElement = document.getElementById(MAP_CONTAINER_ID)
      if (mapContainerElement) mapContainerElement.style.height = heightValueToReset

      const contentContainerElement = document.getElementById(CONTENT_CONTAINER_ID)
      if (contentContainerElement) contentContainerElement.style.height = heightValueToReset
    }
  }, [isDesktopMedium])

  // likewise, if the user beings on desktop with a larger viewport width, shrinking to desktop
  // needs to set the fixed pixel values again

  // store the previous value of desktopMedium, so we know if we got bigger or smaller in next useEffect
  const [prevDesktopMedium, setPrevDesktopMedium] = useState(false)
  useEffect(() => {
    setPrevDesktopMedium(!!isDesktopMedium)
  }, [isDesktopMedium])

  useEffect(() => {
    if (isDesktopMedium || !prevDesktopMedium) return

    window.addEventListener('resize', setPixelHeights)
    setPixelHeights()

    return () => {
      window.removeEventListener('resize', setPixelHeights)
      const htmlElement = document.querySelector('html')
      if (htmlElement) htmlElement.style.removeProperty('height')
    }
  }, [isDesktopMedium])

  return {
    CONTENT_CONTAINER_ID,
    MAP_CONTAINER_ID,
  }
}

export default useWindowHeightCorrection
